import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'gdp-trial-link-main',
  templateUrl: './trial-link-main.component.html',
  styleUrls: ['./trial-link-main.component.scss']
})
export class TrialLinkMainComponent { }
